import { render, staticRenderFns } from "./EditPrices.vue?vue&type=template&id=c37b5eb2"
import script from "./EditPrices.vue?vue&type=script&lang=js"
export * from "./EditPrices.vue?vue&type=script&lang=js"
import style0 from "./EditPrices.vue?vue&type=style&index=0&id=c37b5eb2&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c37b5eb2')) {
      api.createRecord('c37b5eb2', component.options)
    } else {
      api.reload('c37b5eb2', component.options)
    }
    module.hot.accept("./EditPrices.vue?vue&type=template&id=c37b5eb2", function () {
      api.rerender('c37b5eb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/price/EditPrices.vue"
export default component.exports